import { Toaster as Sonner } from "sonner";
import { createPortal } from "react-dom";
import CloseIcon from "@/assets/icons/close.svg?react";
import CheckIcon from "@/assets/icons/check.svg?react";
import AlertIcon from "@/assets/icons/alert-circle.svg?react";
import VibratingButton from "@/components/base/button/VibratingButton.tsx";

type ToasterProps = React.ComponentProps<typeof Sonner>;

const StatusIcon = () => {
  return (
    <VibratingButton className="size-7 bg-green  rounded-md flex-center">
      <CheckIcon className="size-[22px] text-white" />
    </VibratingButton>
  );
};

const ErrorIcon = () => {
  return (
    <VibratingButton className="bg-red size-7 rounded-md flex-center">
      <AlertIcon className="size-4" strokeWidth={2.5} />
    </VibratingButton>
  );
};

const Toaster = ({ ...props }: ToasterProps) => {
  const toastContent = (
    <Sonner
      className="toaster group"
      closeButton
      icons={{
        close: <CloseIcon className="size-5" />,
        success: <StatusIcon />,
        warning: <ErrorIcon />,
        error: <ErrorIcon />,
      }}
      toastOptions={{
        classNames: {
          toast:
            "group h-[60px] toast group-[.toaster]:bg-black/60 backdrop-blur-[20px] group-[.toaster]:text-foreground group-[.toaster]:border-none group-[.toaster]:shadow-lg group-[.toaster]:gap-3 group-hover:!h-[60px]",
          description: "group-[.toast]:!text-white",
          icon: "!size-[22px]",
          content: "pr-4",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
          closeButton:
            "!right-4 !left-auto !top-1/2 !-translate-y-1/2 !bg-transparent !border-none !text-white",
        },
      }}
      {...props}
    />
  );

  // Only render in the browser
  if (typeof window === "undefined") return null;

  return createPortal(toastContent, document.body);
};

export { Toaster };
